import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { addProtRad, removeProtRad } from "../../../../../../../../../../../redux/actions/resolucion";
import ProtRadFormContainer from "./ProtRadFormContainer";
import ProtRadTable from "./ProtRadTable";

const ProtRadTableContainer = ({ }) => {
    const dispatch = useDispatch();
    const idDependenciaEmpleador = useSelector(
        (state) => state.resolucion.searchedEstablecimiento
    );

    const data = useSelector(
        (state) => state.resolucion.abmEquiposRadiologicos.protRad
    );

    const [openProtRadForm, setOpenProtRadForm] = useState(false);
    const [protRad, setProtRad] = useState(null);

    const handleRemoveProtRad = (row) => {
        dispatch(removeProtRad(row));
    };
    const handleOpenProtRadForm = (rowData) => {
        setOpenProtRadForm(true);
        setProtRad(rowData);
    };

    const handleSubmitProtRad = (values) => {
        const body = {
            ...values,
            idDependenciaEmpleador: idDependenciaEmpleador,
        };
        dispatch(addProtRad(body, values?.index));
        setOpenProtRadForm(false);
    };

    return (
        <>
            <ProtRadTable
                handleDelete={handleRemoveProtRad}
                handleOpenForm={handleOpenProtRadForm}
                data={data}
            />
            <ProtRadFormContainer
                handleClose={() => setOpenProtRadForm(false)}
                open={openProtRadForm}
                handleSubmit={handleSubmitProtRad}
                values={protRad}
            />
        </>
    )
}

export default ProtRadTableContainer;